import React from "react"
import tinycolor from 'tinycolor2'

import plateStyles from './plate_styles.module.scss'

const TeamPlate = ({ nodeData, index, sortDirection }) => {

    const lighten = '#ffffff'

    return (
        <div className={plateStyles.teamPlateContainer}>
            <div className={plateStyles.teamPlateIndex}>
                {sortDirection === 'asc' ? 32 - index : index + 1 }
            </div>
            <div className={plateStyles.teamPlateLogoContainer} style={{
                background: tinycolor.mix(lighten, nodeData.team_color, 17)
            }}>
                <img
                    className={plateStyles.teamPlateLogo}
                    src={nodeData.team_logo_espn}
                    alt={`${nodeData.team_nick} logo`}
                />
            </div>
            <div className={plateStyles.teamName}>
                {nodeData.team_nick}    
            </div>
            <div className={plateStyles.teamNameMobile}>
                {nodeData.team}    
            </div>
        </div>
    )
    
}

export default TeamPlate




